import styled from 'styled-components';

import {
  HERO_FONT_BODY,
  HERO_FONT_DISPLAY,
  LandingHero,
} from 'constants/landing-hero';

import { blink, gradientShift, rise } from './keyframes';

const MOBILE = '@media (max-width: 760px)';

export const Section = styled.section`
  position: relative;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  color: ${LandingHero.textBody};
  font-family: ${HERO_FONT_BODY};
`;

export const Main = styled.main`
  position: relative;
  z-index: 1;
  flex: 1;
  width: 100%;
  max-width: 128rem;
  margin: 0 auto;
  padding: clamp(2.4rem, 4vh, 6.4rem) 2.4rem clamp(3.2rem, 5vh, 7.2rem);
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const Badge = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 1rem;
  padding: 0.8rem 1.6rem 0.8rem 1.2rem;
  border-radius: 999rem;
  background: ${LandingHero.badgeBg};
  border: 0.1rem solid ${LandingHero.badgeBorder};
  box-shadow: 0 0 3rem -0.8rem ${LandingHero.badgeShadow};
  font-size: 1.3rem;
  font-weight: 700;
  letter-spacing: 0.04rem;
  color: ${LandingHero.badgeText};
  opacity: 0;
  animation: ${rise} 0.9s cubic-bezier(0.2, 0.8, 0.2, 1) 0.18s forwards;

  @media (prefers-reduced-motion: reduce) {
    opacity: 1;
    animation: none;
  }
`;

export const LiveDot = styled.span`
  width: 0.8rem;
  height: 0.8rem;
  border-radius: 50%;
  background: ${LandingHero.liveDot};
  box-shadow: 0 0 1rem ${LandingHero.liveDot};
  animation: ${blink} 1.8s ease-in-out infinite;

  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }
`;

export const Title = styled.h1`
  margin: clamp(1.6rem, 2.5vh, 2.8rem) 0 0;
  max-width: 96rem;
  text-align: center;
  font-family: ${HERO_FONT_DISPLAY};
  font-weight: 800;
  font-size: clamp(3.6rem, 7vh, 7.6rem);
  line-height: 1.04;
  letter-spacing: -0.25rem;
  color: ${LandingHero.textPrimary};
  opacity: 0;
  animation: ${rise} 0.9s cubic-bezier(0.2, 0.8, 0.2, 1) 0.3s forwards;

  ${MOBILE} {
    font-size: 4rem;
    letter-spacing: -0.1rem;
  }

  @media (prefers-reduced-motion: reduce) {
    opacity: 1;
    animation: none;
  }
`;

export const Gradient = styled.span`
  background: ${LandingHero.headlineGradient};
  background-size: 220% 100%;
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  animation: ${gradientShift} 8s ease-in-out infinite;

  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }
`;

export const Subtitle = styled.p`
  margin: clamp(1.2rem, 2vh, 2.4rem) 0 0;
  max-width: 62rem;
  text-align: center;
  font-size: clamp(1.6rem, 2vh, 1.9rem);
  line-height: 1.6;
  color: ${LandingHero.textMuted};
  opacity: 0;
  animation: ${rise} 0.9s cubic-bezier(0.2, 0.8, 0.2, 1) 0.45s forwards;

  @media (prefers-reduced-motion: reduce) {
    opacity: 1;
    animation: none;
  }
`;

export const CardGrid = styled.div`
  width: 100%;
  max-width: 118rem;
  margin-top: clamp(2.4rem, 4vh, 6.4rem);
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(min(100%, 42rem), 1fr));
  gap: 2.8rem;
  opacity: 0;
  animation: ${rise} 0.9s cubic-bezier(0.2, 0.8, 0.2, 1) 0.6s forwards;

  @media (prefers-reduced-motion: reduce) {
    opacity: 1;
    animation: none;
  }
`;
